import "./MensajeCard.css";

const VARIABLES = [
  "{NOMBRE}",
  "{PACIENTE}",
  "{EMAIL}",
  "{TELEFONO}",
];

export default function MensajeCard({
  campaign,
  setCampaign,
}) {

  const updateField = (field, value) => {
    setCampaign(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const insertVariable = (variable) => {

    updateField(
      "body",
      campaign.body + variable
    );

  };

  return (

    <div className="campaign-card">

      <div className="campaign-card-header">

        <div className="campaign-card-icon">
          <i className="fa-solid fa-envelope-open-text"></i>
        </div>

        <div>

          <h2>Correo</h2>

          <p>
            Escribe el asunto y el contenido que recibirán los destinatarios.
          </p>

        </div>

      </div>

      <div className="message-group">

        <label>

          Asunto

        </label>

        <input
          type="text"
          placeholder="Ej. Información importante sobre septiembre"
          value={campaign.subject}
          onChange={(e) =>
            updateField("subject", e.target.value)
          }
        />

      </div>

      <div className="message-group">

        <label>

          Mensaje

        </label>

        <textarea

          placeholder={`Hola {NOMBRE},

Queríamos informaros de...

Muchas gracias.

Equipo TE AYUDO.`}

          value={campaign.body}

          onChange={(e) =>
            updateField("body", e.target.value)
          }

        />

      </div>

      <div className="variables-box">

        <h3>

          Variables disponibles

        </h3>

        <p>

          Pulsa sobre una variable para insertarla en el mensaje.

        </p>

        <div className="variables-list">

          {VARIABLES.map(variable => (

            <button
              key={variable}
              type="button"
              onClick={() => insertVariable(variable)}
            >

              {variable}

            </button>

          ))}

        </div>

      </div>

      <div className="message-info">

        <div>

          <strong>

            {campaign.subject.length}

          </strong>

          <span>

            caracteres en el asunto

          </span>

        </div>

        <div>

          <strong>

            {campaign.body.length}

          </strong>

          <span>

            caracteres en el mensaje

          </span>

        </div>

      </div>

    </div>

  );

}